import React from "react";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";
import { OrderDisplayData, OrderProduct } from "../types/order";

interface TableRow {
  id: number;
  sno: number;
  name: string;
  price: string | number;
  qty: number;
  total: string;
}

interface OrderItemsTableProps {
  order: OrderDisplayData;
}

const OrderItemsTable: React.FC<OrderItemsTableProps> = ({ order }) => {
  const allProducts: OrderProduct[] = [...(order.Products || []), ...(order.products || [])];

  const tableData: TableRow[] = allProducts.map((p, index) => {
    const price = (Number(p.amount) || 0).toFixed(2);
    const qty = p.quantity || 1;
    return {
      id: index + 1,
      sno: index + 1,
      name: p.name,
      price,
      qty,
      total: Number(p.totalPrice).toFixed(2),
    };
  });

  const headCells: HeadCell<TableRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "name", label: "Product" },
    { id: "price", label: "Price (QAR)", align: "right" },
    { id: "qty", label: "Qty", align: "center" },
    { id: "total", label: "Total (QAR)", align: "right" },
  ];

  return (
    <CommonTable
      data={tableData}
      headCells={headCells}
      title="Order Items"
      selectable={false}
      pagenation={true}
      showToolbar={false}
      pageSize={10}
      className="border-none shadow-md rounded-md"
    />
  );
};

export default OrderItemsTable;
